import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5d0a6dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addRouteCardInner" }
const _hoisted_2 = { class: "addRouteCardTitle" }

import { Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDictionary } from '@components/dictionary';
import { AddRouteSubscription } from '../AddRouteSubscription';
import { RouteDetail, RouteSubscriptionViewModel } from '../../types';
import { useRouteSubscriptionStore } from '../../stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddRouteSubscriptionCard',
  props: {
    routes: {}
  },
  emits: ["saved", "cancel"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useI18n();
const { DictionaryField, dictionary } = useDictionary();
const routeSubscriptionsStore = useRouteSubscriptionStore();
const {
  addSubscription, getSubscriptions,
} = routeSubscriptionsStore;

const subscription: Ref<RouteSubscriptionViewModel> = ref({
  startDate: undefined,
  endDate: undefined,
  textCode: undefined,
});

const apiError = ref('');
const clearAddRouteValues = () => {
  subscription.value = {
    startDate: undefined,
    endDate: undefined,
    textCode: undefined,
  };
};

const handleUpdateEndDate = (value: string) => {
  subscription.value.endDate = value;
};

const handleUpdateTextCode = (value: string) => {
  subscription.value.textCode = value;
};

const handleUpdateStartDate = (value: string) => {
  subscription.value.startDate = value;
};

const handleCancel = () => {
  emit('cancel');
  apiError.value = '';
};

const handleSave = async () => {
  apiError.value = '';

  addSubscription(
    {
      routeSubscription: {
        startDate: subscription.value.startDate || '',
        endDate: subscription.value.endDate || '',
        textCode: subscription.value.textCode || '',
      },
      onApiSuccess: () => {
        clearAddRouteValues();
        getSubscriptions();
        emit('saved');
      },
      onApiError: () => {
        apiError.value = t('SMS Api error');
      },
    },
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('Add new route')), 1),
    _createVNode(_unref(AddRouteSubscription), {
      "how-it-works-title": 
        _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Title']]
      ,
      "how-it-works-description-markdown": 
        _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Description']]
      ,
      routes: _ctx.routes,
      "alert-title": _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Alert:Title']],
      "start-date": subscription.value.startDate,
      "end-date": subscription.value.endDate,
      "text-code": subscription.value.textCode,
      "alert-description-markdown": 
        _unref(dictionary)[_unref(DictionaryField)['SMS:Web:HowItWorks:Alert:Description']]
      ,
      "is-loading": _unref(routeSubscriptionsStore).isSubscriptionAdding,
      "api-error": apiError.value,
      onUpdateEndDate: handleUpdateEndDate,
      onUpdateTextCode: handleUpdateTextCode,
      onUpdateStartDate: handleUpdateStartDate,
      onSave: handleSave,
      onCancel: handleCancel
    }, null, 8, ["how-it-works-title", "how-it-works-description-markdown", "routes", "alert-title", "start-date", "end-date", "text-code", "alert-description-markdown", "is-loading", "api-error"])
  ]))
}
}

})